export { default } from "./SimilarMenuItemsCarousel";
